/* global axios */
import ApiClient from './ApiClient';

class PlanosAPI extends ApiClient {
  constructor() {
    super('planos', { accountScoped: true });
  }

  index() {
    return axios.get(this.url);
  }

  checkout(url) {
    return axios.post(url || this.url);
  }

  setup(url) {
    return axios.post(url || this.url);
  }

  cancelSubscription(payload = {}) {
    return axios.patch(`${this.url}/subscription`, payload);
  }
}

export default new PlanosAPI();
